const ko = {
  홈페이지: '홈페이지',
  '교사 LMS': '교사 LMS',
  이용가이드: '이용가이드',
  안내: '안내',
  아이디: '아이디',
  이름: '이름',
  비밀번호: '비밀번호',
  'ID 로그인': 'ID 로그인',
  '학년반 로그인': '학년반 로그인',
  '학교 검색': '학교 검색',
  '국가 설정': '위치',
  '로그인할 위치를 선택하세요.': '로그인할 위치를 선택하세요.',
  regionListLabel: '검색 결과',
  '국가 목록을 불러오지 못했습니다.': '국가 목록을 불러오지 못했습니다.',
  '학년 선택': '학년 선택',
  gradeLabel: '{grade}학년',
  '반 선택': '반 선택',
  classLabel: '{classNum}반',
  무료체험: '무료체험',
  '학교를 먼저 선택해주세요.': '학교를 먼저 선택해주세요.',
  '서버 점검 중입니다.': '서버 점검 중입니다.',
  '학교 이름을 검색하여, 선택해주세요.': '학교 이름을 검색하여, 선택해주세요.',
  '학교를 검색해주세요.': '학교를 검색해주세요.',
  '검색 결과': '검색 결과',
  '검색 결과가 없습니다.': '검색 결과가 없습니다.',
  '{{schoolName}} 으로 설정되었습니다.': '{{schoolName}} 으로 설정되었습니다.',
  '학급 코드를 입력해주세요.': '학급 코드를 입력해주세요.',
  '학급 코드 입력': '학급 코드 입력',
  '선생님이 알려주신 학급 코드를 정확하게 입력해주세요.':
    '선생님이 알려주신 학급 코드를 정확하게 입력해주세요.',
  '사용할 수 없는 코드입니다.': '사용할 수 없는 코드입니다.',
  '존재하지 않는 코드입니다.': '존재하지 않는 코드입니다.',
  '선생님께 문의해주세요.': '선생님께 문의해주세요.',
  '가입할 수 있는 인원이 초과된 코드입니다.': '가입할 수 있는 인원이 초과된 코드입니다.',
  studentStatusLabel: '{schoolName}초등학교 {grade}학년 {classNum}반 학생입니다.',
  '가입을 계속하려면, 아래 OK 버튼을 눌러주세요.':
    '가입을 계속하려면, 아래 OK 버튼을 눌러주세요.',
  '로그인 정보를 입력해주세요.': '로그인 정보를 입력해주세요.',
  '아이디 또는 비밀번호를 잘못 입력했습니다.':
    '아이디 또는 비밀번호를 잘못 입력했습니다.',
  '계약이 만료된 계정입니다.': '계약이 만료된 계정입니다.',
  '로그인 중 오류가 발생하였습니다.': '로그인 중 오류가 발생하였습니다.',
  '회원 정보 입력': '회원 정보 입력',
  '나만 아는 비밀번호를 입력해주세요.': '나만 아는 비밀번호를 입력해주세요.',
  '새 비밀번호': '새 비밀번호',
  '비밀번호 확인': '비밀번호 확인',
  '비밀번호는 영문 대소문자/숫자 조합 6자 이상 가능합니다.':
    '비밀번호는 영문 대소문자/숫자 조합 6자 이상 가능합니다.',
  '비밀번호가 일치하지 않습니다.': '비밀번호가 일치하지 않습니다.',
  '새로운 비밀번호로 다시 로그인해주세요!':
    '새로운 비밀번호로 다시 로그인해주세요!',
  '비밀번호 설정 중 오류가 발생하였습니다':
    '비밀번호 설정 중 오류가 발생하였습니다',
  '비밀번호는 대소문자를 포함해 6자이상이여야 합니다.':
    '비밀번호는 대소문자를 포함해 6자이상이여야 합니다.',
  '내 아이디가 맞나요?': '내 아이디가 맞나요?',
  초등학교: '초등학교',
  '현재 초기 비밀번호로 설정되어 있습니다.':
    '현재 초기 비밀번호로 설정되어 있습니다.',
  '비밀번호 변경이 필요합니다.': '비밀번호 변경이 필요합니다.',
  '나만의 닉네임을 만들어주세요.': '나만의 닉네임을 만들어주세요.',
  '닉네임은 2-8글자, 한글/영어/숫자만 가능합니다.':
    '닉네임은 2-8글자, 한글/영어/숫자만 가능합니다.',
  '나만의 닉네임을 확인해주세요.': '나만의 닉네임을 확인해주세요.',
  '사용 가능한 닉네임입니다. 이 닉네임으로 사용하시겠어요?':
    '사용 가능한 닉네임입니다. 이 닉네임으로 사용하시겠어요?',
  '닉네임을 2~8 글자로 설정해주세요.': '닉네임을 2~8 글자로 설정해주세요.',
  '닉네임에 비속어를 사용할 수 없습니다.':
    '닉네임에 비속어를 사용할 수 없습니다.',
  '이미 존재하는 닉네임입니다.': '이미 존재하는 닉네임입니다.',
  '잘못된 형식의 닉네임입니다. 다른 닉네임을 사용해주세요.':
    '잘못된 형식의 닉네임입니다. 다른 닉네임을 사용해주세요.',
  '국가선택체크모달':
    '{location} ID로만 로그인 할 수 있습니다.\n{location}{을를} 맞게 선택했나요?',
  '국가변경체크모달': '다른 위치를 선택할까요?',
  '국가변경체크모달안내': "변경할 위치의 아이디가 필요합니다."
}

const vt = {
  홈페이지: 'Trang chủ',
  '교사 LMS': 'LMS',
  이용가이드: 'Hướng dẫn',
  안내: 'Guide',
  아이디: 'ID',
  이름: 'Name',
  비밀번호: 'Password',
  'ID 로그인': 'Đăng nhập ID',
  '학년반 로그인': 'Đăng nhập theo lớp',
  '학교 검색': 'Tìm trường',
  '국가 설정': 'Khu vực',
  '로그인할 위치를 선택하세요.': 'Chọn khu vực đăng nhập của bạn.',
  regionListLabel: 'Chọn từ danh sách bên dưới.',
  '국가 목록을 불러오지 못했습니다.': 'Không thể tải danh sách quốc gia.',
  '학년 선택': 'Chọn khối',
  gradeLabel: 'Khối {grade}',
  '반 선택': 'Chọn lớp',
  classLabel: 'Lớp {classNum}',
  무료체험: 'Dùng thử miễn phí',
  '학교를 먼저 선택해주세요.': 'Vui lòng chọn trường trước.',
  '서버 점검 중입니다.': 'Máy chủ đang bảo trì.',
  '학교 이름을 검색하여, 선택해주세요.': 'Hãy tìm kiếm và chọn tên trường.',
  '학교를 검색해주세요.': 'Vui lòng tìm trường.',
  '검색 결과': 'Kết quả tìm kiếm',
  '검색 결과가 없습니다.': 'Không có kết quả tìm kiếm.',
  '{{schoolName}} 으로 설정되었습니다.': 'Đã đặt thành {{schoolName}}.',
  '학급 코드를 입력해주세요.': 'Vui lòng nhập mã lớp.',
  '학급 코드 입력': 'Nhập mã lớp',
  '선생님이 알려주신 학급 코드를 정확하게 입력해주세요.':
    'Vui lòng nhập chính xác mã lớp do giáo viên cung cấp.',
  '사용할 수 없는 코드입니다.': 'Mã này không thể sử dụng.',
  '존재하지 않는 코드입니다.': 'Mã không tồn tại.',
  '선생님께 문의해주세요.': 'Vui lòng liên hệ giáo viên.',
  '가입할 수 있는 인원이 초과된 코드입니다.': 'Mã này đã vượt quá số lượng thành viên.',
  studentStatusLabel: 'Bạn là học sinh lớp {classNum}, khối {grade} của trường tiểu học {schoolName}.',
  '가입을 계속하려면, 아래 OK 버튼을 눌러주세요.':
    'Để tiếp tục đăng ký, hãy nhấn nút OK bên dưới.',
  '로그인 정보를 입력해주세요.': 'Vui lòng nhập thông tin đăng nhập.',
  '아이디 또는 비밀번호를 잘못 입력했습니다.': 'ID hoặc mật khẩu không đúng.',
  '계약이 만료된 계정입니다.': 'Tài khoản đã hết hạn.',
  '로그인 중 오류가 발생하였습니다.': 'Lỗi xảy ra khi đăng nhập.',
  '회원 정보 입력': 'Nhập thông tin thành viên',
  '나만 아는 비밀번호를 입력해주세요.': 'Vui lòng nhập mật khẩu chỉ bạn biết.',
  '새 비밀번호': 'Mật khẩu mới',
  '비밀번호 확인': 'Xác nhận mật khẩu',
  '비밀번호는 영문 대소문자/숫자 조합 6자 이상 가능합니다.':
    'Mật khẩu phải có ít nhất 6 ký tự bao gồm chữ và số.',
  '비밀번호가 일치하지 않습니다.': 'Mật khẩu không khớp.',
  '새로운 비밀번호로 다시 로그인해주세요!': 'Đăng nhập lại bằng mật khẩu mới!',
  '비밀번호 설정 중 오류가 발생하였습니다':
    'Lỗi xảy ra khi thiết lập mật khẩu.',
  '비밀번호는 대소문자를 포함해 6자이상이여야 합니다.':
    'Mật khẩu phải có ít nhất 6 ký tự bao gồm chữ hoa và chữ thường.',
  '내 아이디가 맞나요?': 'ID của tôi có đúng không?',
  초등학교: 'Tiểu học',
  '현재 초기 비밀번호로 설정되어 있습니다.':
    'Hiện tại được đặt bằng mật khẩu ban đầu.',
  '비밀번호 변경이 필요합니다.': 'Cần thay đổi mật khẩu.',
  '나만의 닉네임을 만들어주세요.': 'Tạo biệt danh của riêng bạn.',
  '닉네임은 2-8글자, 한글/영어/숫자만 가능합니다.':
    'Biệt danh phải từ 2-8 ký tự, chỉ chữ Hàn/Anh/số.',
  '나만의 닉네임을 확인해주세요.': 'Kiểm tra biệt danh của riêng bạn.',
  '사용 가능한 닉네임입니다. 이 닉네임으로 사용하시겠어요?':
    'Biệt danh có sẵn. Bạn muốn sử dụng biệt danh này không?',
  '닉네임을 2~8 글자로 설정해주세요.': 'Đặt biệt danh từ 2-8 ký tự.',
  '닉네임에 비속어를 사용할 수 없습니다.':
    'Không thể sử dụng từ ngữ thô tục cho biệt danh.',
  '이미 존재하는 닉네임입니다.': 'Biệt danh đã tồn tại.',
  '잘못된 형식의 닉네임입니다. 다른 닉네임을 사용해주세요.':
    'Tên người dùng không khả dụng.',
  '국가선택체크모달':
    'Bạn chỉ có thể đăng nhập bằng ID của {location}.\nBạn đã chọn đúng {location} chưa?'
}

const en = {
  홈페이지: 'Homepage',
  '교사 LMS': 'LMS',
  이용가이드: 'User Guide',
  안내: 'Notice',
  아이디: 'ID',
  이름: 'Name',
  비밀번호: 'Password',
  'ID 로그인': 'ID Login',
  '학년반 로그인': 'Grade/Class Login',
  '학교 검색': 'School Lookup',
  '국가 설정': 'Location',
  '로그인할 위치를 선택하세요.': 'Choose your location to log in.',
  regionListLabel: 'Choose from the list below.',
  '국가 목록을 불러오지 못했습니다.': 'Failed to load the country list.',
  '학년 선택': 'Select Grade',
  gradeLabel: 'Grade {grade}',
  '반 선택': 'Select Class',
  classLabel: 'Class {classNum}',
  무료체험: 'Free Trial',
  '학교를 먼저 선택해주세요.': 'Please select a school first.',
  '서버 점검 중입니다.': 'Server is under maintenance.',
  '학교 이름을 검색하여, 선택해주세요.': 'Search and select your school name.',
  '학교를 검색해주세요.': 'Please search for your school.',
  '검색 결과': 'Search Results',
  '검색 결과가 없습니다.': 'No search results found.',
  '{{schoolName}} 으로 설정되었습니다.': 'Set to {{schoolName}}.',
  '학급 코드를 입력해주세요.': 'Please enter the class code.',
  '학급 코드 입력': 'Enter class code',
  '선생님이 알려주신 학급 코드를 정확하게 입력해주세요.':
    'Please enter the class code exactly as your teacher provided.',
  '사용할 수 없는 코드입니다.': 'This code cannot be used.',
  '존재하지 않는 코드입니다.': 'This code does not exist.',
  '선생님께 문의해주세요.': 'Please contact your teacher.',
  '가입할 수 있는 인원이 초과된 코드입니다.': 'This code has reached its member limit.',
  studentStatusLabel: 'You are a grade {grade}, class {classNum} student at {schoolName} Elementary School.',
  '가입을 계속하려면, 아래 OK 버튼을 눌러주세요.':
    'To continue sign-up, please press the OK button below.',
  '로그인 정보를 입력해주세요.': 'Please enter your login information.',
  '아이디 또는 비밀번호를 잘못 입력했습니다.':
    'The ID or password you entered is incorrect.',
  '계약이 만료된 계정입니다.': 'This account has an expired contract.',
  '로그인 중 오류가 발생하였습니다.': 'An error occurred during login.',
  '회원 정보 입력': 'Enter member information',
  '나만 아는 비밀번호를 입력해주세요.': 'Please enter a password only you know.',
  '새 비밀번호': 'New Password',
  '비밀번호 확인': 'Confirm Password',
  '비밀번호는 영문 대소문자/숫자 조합 6자 이상 가능합니다.':
    'Password must be at least 6 characters using letters and numbers.',
  '비밀번호가 일치하지 않습니다.': 'Passwords do not match.',
  '새로운 비밀번호로 다시 로그인해주세요!':
    'Please log in again with your new password!',
  '비밀번호 설정 중 오류가 발생하였습니다':
    'An error occurred while setting the password.',
  '비밀번호는 대소문자를 포함해 6자이상이여야 합니다.':
    'Password must be at least 6 characters including upper/lower case letters.',
  '내 아이디가 맞나요?': 'Is this my ID?',
  초등학교: 'Elementary School',
  '현재 초기 비밀번호로 설정되어 있습니다.':
    'Your account is currently set to the initial password.',
  '비밀번호 변경이 필요합니다.': 'You need to change your password.',
  '나만의 닉네임을 만들어주세요.': 'Please create your own nickname.',
  '닉네임은 2-8글자, 한글/영어/숫자만 가능합니다.':
    'Nickname must be 2-8 characters using Korean/English/numbers only.',
  '나만의 닉네임을 확인해주세요.': 'Please confirm your nickname.',
  '사용 가능한 닉네임입니다. 이 닉네임으로 사용하시겠어요?':
    'This nickname is available. Would you like to use it?',
  '닉네임을 2~8 글자로 설정해주세요.': 'Please set your nickname to 2-8 characters.',
  '닉네임에 비속어를 사용할 수 없습니다.':
    'Profanity cannot be used in nicknames.',
  '이미 존재하는 닉네임입니다.': 'This nickname already exists.',
  '잘못된 형식의 닉네임입니다. 다른 닉네임을 사용해주세요.':
    'Invalid nickname format. Please use a different nickname.',
  '국가선택체크모달':
    'Only an ID from {location} can log in with this.\nDid you choose {location} correctly?',
  '국가변경체크모달': 'Do you want to choose a different location?',
  '국가변경체크모달안내': "You'll need an ID from that location to log in."
}

const zh = {
  홈페이지: '首页',
  '교사 LMS': 'LMS',
  이용가이드: '使用指南',
  안내: '提示',
  아이디: '账号',
  이름: '姓名',
  비밀번호: '密码',
  'ID 로그인': 'ID登录',
  '학년반 로그인': '年级班级登录',
  '학교 검색': '搜索学校',
  '국가 설정': '国家设置',
  '로그인할 위치를 선택하세요.': '请选择您登录的位置。',
  regionListLabel: '请从下面的列表中选择。',
  '국가 목록을 불러오지 못했습니다.': '无法加载国家列表。',
  '학년 선택': '选择年级',
  gradeLabel: '{grade}年级',
  '반 선택': '选择班级',
  classLabel: '{classNum}班',
  무료체험: '免费体验',
  '학교를 먼저 선택해주세요.': '请先选择学校。',
  '서버 점검 중입니다.': '服务器维护中。',
  '학교 이름을 검색하여, 선택해주세요.': '请搜索并选择学校名称。',
  '학교를 검색해주세요.': '请搜索学校。',
  '검색 결과': '搜索结果',
  '검색 결과가 없습니다.': '没有搜索结果。',
  '{{schoolName}} 으로 설정되었습니다.': '已设置为{{schoolName}}。',
  '학급 코드를 입력해주세요.': '请输入班级代码。',
  '학급 코드 입력': '输入班级代码',
  '선생님이 알려주신 학급 코드를 정확하게 입력해주세요.':
    '请准确输入老师提供的班级代码。',
  '사용할 수 없는 코드입니다.': '该代码不可用。',
  '존재하지 않는 코드입니다.': '该代码不存在。',
  '선생님께 문의해주세요.': '请联系老师。',
  '가입할 수 있는 인원이 초과된 코드입니다.': '该代码可加入人数已满。',
  studentStatusLabel: '你是{schoolName}小学{grade}年级{classNum}班学生。',
  '가입을 계속하려면, 아래 OK 버튼을 눌러주세요.':
    '若要继续注册，请点击下方OK按钮。',
  '로그인 정보를 입력해주세요.': '请输入登录信息。',
  '아이디 또는 비밀번호를 잘못 입력했습니다.': '账号或密码输入错误。',
  '계약이 만료된 계정입니다.': '该账号合同已到期。',
  '로그인 중 오류가 발생하였습니다.': '登录时发生错误。',
  '회원 정보 입력': '输入会员信息',
  '나만 아는 비밀번호를 입력해주세요.': '请输入仅你知道的密码。',
  '새 비밀번호': '新密码',
  '비밀번호 확인': '确认密码',
  '비밀번호는 영문 대소문자/숫자 조합 6자 이상 가능합니다.':
    '密码需至少6位，包含字母和数字。',
  '비밀번호가 일치하지 않습니다.': '密码不一致。',
  '새로운 비밀번호로 다시 로그인해주세요!': '请使用新密码重新登录！',
  '비밀번호 설정 중 오류가 발생하였습니다': '设置密码时发生错误。',
  '비밀번호는 대소문자를 포함해 6자이상이여야 합니다.':
    '密码至少6位，需包含大小写字母。',
  '내 아이디가 맞나요?': '这是我的账号吗？',
  초등학교: '小学',
  '현재 초기 비밀번호로 설정되어 있습니다.': '当前为初始密码。',
  '비밀번호 변경이 필요합니다.': '需要修改密码。',
  '나만의 닉네임을 만들어주세요.': '请创建你的昵称。',
  '닉네임은 2-8글자, 한글/영어/숫자만 가능합니다.':
    '昵称需为2-8位，仅限韩文/英文/数字。',
  '나만의 닉네임을 확인해주세요.': '请确认你的昵称。',
  '사용 가능한 닉네임입니다. 이 닉네임으로 사용하시겠어요?':
    '该昵称可用。是否使用此昵称？',
  '닉네임을 2~8 글자로 설정해주세요.': '请将昵称设置为2~8个字符。',
  '닉네임에 비속어를 사용할 수 없습니다.': '昵称不能包含脏话。',
  '이미 존재하는 닉네임입니다.': '该昵称已存在。',
  '잘못된 형식의 닉네임입니다. 다른 닉네임을 사용해주세요.':
    '昵称格式不正确，请使用其他昵称。',
  '국가선택체크모달': '只能使用{location}的ID登录。\n您选择的{location}正确吗？'
}

const ja = {
  홈페이지: 'ホームページ',
  '교사 LMS': 'LMS',
  이용가이드: '利用ガイド',
  안내: '案内',
  아이디: 'ID',
  이름: '名前',
  비밀번호: 'パスワード',
  'ID 로그인': 'IDログイン',
  '학년반 로그인': '学年・クラスログイン',
  '학교 검색': '学校検索',
  '국가 설정': '国設定',
  '로그인할 위치를 선택하세요.': 'ログインする地域を選択してください。',
  regionListLabel: '下のリストから選択してください。',
  '국가 목록을 불러오지 못했습니다.': '国リストを読み込めませんでした。',
  '학년 선택': '学年選択',
  gradeLabel: '{grade}年',
  '반 선택': 'クラス選択',
  classLabel: '{classNum}組',
  무료체험: '無料体験',
  '학교를 먼저 선택해주세요.': '先に学校を選択してください。',
  '서버 점검 중입니다.': 'サーバーメンテナンス中です。',
  '학교 이름을 검색하여, 선택해주세요.': '学校名を検索して選択してください。',
  '학교를 검색해주세요.': '学校を検索してください。',
  '검색 결과': '検索結果',
  '검색 결과가 없습니다.': '検索結果がありません。',
  '{{schoolName}} 으로 설정되었습니다.': '{{schoolName}} に設定されました。',
  '학급 코드를 입력해주세요.': 'クラスコードを入力してください。',
  '학급 코드 입력': 'クラスコード入力',
  '선생님이 알려주신 학급 코드를 정확하게 입력해주세요.':
    '先生から案内されたクラスコードを正確に入力してください。',
  '사용할 수 없는 코드입니다.': '使用できないコードです。',
  '존재하지 않는 코드입니다.': '存在しないコードです。',
  '선생님께 문의해주세요.': '先生にお問い合わせください。',
  '가입할 수 있는 인원이 초과된 코드입니다.': 'このコードは参加可能人数を超えています。',
  studentStatusLabel: '{schoolName}小学校 {grade}年 {classNum}組の生徒です。',
  '가입을 계속하려면, 아래 OK 버튼을 눌러주세요.':
    '登録を続けるには、下のOKボタンを押してください。',
  '로그인 정보를 입력해주세요.': 'ログイン情報を入力してください。',
  '아이디 또는 비밀번호를 잘못 입력했습니다.':
    'IDまたはパスワードが正しくありません。',
  '계약이 만료된 계정입니다.': '契約期限が切れたアカウントです。',
  '로그인 중 오류가 발생하였습니다.': 'ログイン中にエラーが発生しました。',
  '회원 정보 입력': '会員情報入力',
  '나만 아는 비밀번호를 입력해주세요.': '自分だけが知っているパスワードを入力してください。',
  '새 비밀번호': '新しいパスワード',
  '비밀번호 확인': 'パスワード確認',
  '비밀번호는 영문 대소문자/숫자 조합 6자 이상 가능합니다.':
    'パスワードは英字と数字を含む6文字以上で入力してください。',
  '비밀번호가 일치하지 않습니다.': 'パスワードが一致しません。',
  '새로운 비밀번호로 다시 로그인해주세요!':
    '新しいパスワードでもう一度ログインしてください！',
  '비밀번호 설정 중 오류가 발생하였습니다':
    'パスワード設定中にエラーが発生しました。',
  '비밀번호는 대소문자를 포함해 6자이상이여야 합니다.':
    'パスワードは大文字小文字を含む6文字以上である必要があります。',
  '내 아이디가 맞나요?': 'これは私のIDですか？',
  초등학교: '小学校',
  '현재 초기 비밀번호로 설정되어 있습니다.':
    '現在、初期パスワードに設定されています。',
  '비밀번호 변경이 필요합니다.': 'パスワード変更が必要です。',
  '나만의 닉네임을 만들어주세요.': '自分だけのニックネームを作ってください。',
  '닉네임은 2-8글자, 한글/영어/숫자만 가능합니다.':
    'ニックネームは2〜8文字で、韓国語/英語/数字のみ使用できます。',
  '나만의 닉네임을 확인해주세요.': '自分のニックネームを確認してください。',
  '사용 가능한 닉네임입니다. 이 닉네임으로 사용하시겠어요?':
    '使用可能なニックネームです。このニックネームを使いますか？',
  '닉네임을 2~8 글자로 설정해주세요.':
    'ニックネームを2〜8文字で設定してください。',
  '닉네임에 비속어를 사용할 수 없습니다.':
    'ニックネームに不適切な言葉は使えません。',
  '이미 존재하는 닉네임입니다.': 'すでに存在するニックネームです。',
  '잘못된 형식의 닉네임입니다. 다른 닉네임을 사용해주세요.':
    '無効なニックネーム形式です。別のニックネームを使用してください。',
  '국가선택체크모달':
    '{location}のIDでのみログインできます。\n{location}を正しく選びましたか？'
}

export { ko, vt, en, zh, ja }
